const click = require('./click');

function saveAs(blob, name) {
    const a = document.createElement('a');
    a.download = name || blob.name || 'download';
    a.rel = 'noopener';
    a.href = URL.createObjectURL(blob);
    click(a);
    setTimeout(() => URL.revokeObjectURL(a.href), 500);
}

module.exports = saveAs;
